import anime from 'animejs';
import { createAnimation } from '@/assets/js/utils/createAnimation';
import { characterWalk } from '@/assets/js/utils/characterWalk';
import { createRotateAnimation } from '@/assets/js/utils/createRotateAnimation';

const ria_animations = () => {
  return {
    enter(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 4000
        tl
          .add({
            targets: '#ria',
            translateY: characterWalk(options.duration),
            left: ['-20%', '25%'],
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    exit(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 4000
        tl
        .add({
          targets: '#ria',
          scaleX: { value: -1, duration: 1 }, // flip ria
          translateY: characterWalk(options.duration),
          left: ['25%', '-20%'],
          easing: 'linear',
          duration: options.duration,
          begin: options.begin,
          complete: options.complete
        })
      }, options, this)()
    },
    rotate(options) { // not used in module 3
      return createAnimation(createRotateAnimation('#ria'), options, this)()
    },
    walk(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 8000
        options.flipped = options.flipped || false
        tl
          .add({
            targets: '#ria',
            scaleX: {
              value: options.flipped ? -1 : 1,
              duration: 1
            }, // flip aye conditionally
            left: options.left, // gradually move closer to left side of scene.
            // left: ['35%', '20%'], // gradually move closer to left side of scene.
            translateY: characterWalk(options.duration),
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    extendLeftArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#ria_left_arm",
            rotate: '-30deg',
            easing: 'linear',
            duration: 500,
            begin: options.begin
          })
          .add({
            targets: "#ria_left_arm_hand",
            rotate: options.rotate,
            easing: 'linear',
            duration: 500,
            complete: options.complete
          })
      }, options, this)()
    },
    raiseRightArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#ria_right_arm",
            rotate: '-12deg',
            easing: 'linear',
            duration: 500,
            begin: options.begin
          })
          .add({
            targets: "#ria_right_arm_hand",
            rotate: options.rotate,
            easing: 'linear',
            duration: 500,
            complete: options.complete
          })
      }, options, this)()
    },
    lowerRightArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '0deg',
            easing: 'linear',
            duration: 500,
            begin: options.begin
          })
          .add({
            targets: "#ria_right_arm",
            rotate: '0deg',
            easing: 'linear',
            duration: 500,
            complete: options.complete
          })
      }, options, this)()
    },
    rightForeArmWave(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-90deg',
            easing: 'linear',
            duration: 250,
            begin: options.begin
          })
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-100deg',
            easing: 'linear',
            duration: 250,
            begin: options.begin
          })
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-90deg',
            easing: 'linear',
            duration: 250,
            begin: options.begin
          })
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-100deg',
            easing: 'linear',
            duration: 250,
            begin: options.begin
          })
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-90deg',
            easing: 'linear',
            duration: 250,
            begin: options.begin
          })
      }, options, this)()
    },
    leftForeArmWave(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#ria_left_arm_hand",
            rotate: '-100deg',
            easing: 'linear',
            duration: 250,
            begin: options.begin
          })
          .add({
            targets: "#ria_left_arm_hand",
            rotate: '-90deg',
            easing: 'linear',
            duration: 250,
            begin: options.begin
          })
          .add({
            targets: "#ria_left_arm_hand",
            rotate: '-100deg',
            easing: 'linear',
            duration: 250,
            begin: options.begin
          })
          .add({
            targets: "#ria_left_arm_hand",
            rotate: '-90deg',
            easing: 'linear',
            duration: 250,
            begin: options.begin
          })
      }, options, this)()
    },
    raiseLeftArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#ria_left_arm",
            rotate: '-12deg',
            easing: 'linear',
            duration: 500,
            begin: options.begin
          })
          .add({
            targets: "#ria_left_arm_hand",
            rotate: options.rotate,
            easing: 'linear',
            duration: 500,
            complete: options.complete
          })
      }, options, this)()
    },
    lowerLeftArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#ria_left_arm_hand",
            rotate: '0deg',
            easing: 'linear',
            duration: 500,
            begin: options.begin
          })
          .add({
            targets: "#ria_left_arm",
            rotate: '0deg',
            easing: 'linear',
            duration: 500,
            complete: options.complete
          })
      }, options, this)()
    },
    cross_arms(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#ria_left_arm",
            rotate: '-15deg',
            easing: 'linear',
            duration: 700,
            begin: options.begin
          })
          .add({
            offset: '-=700',
            targets: "#ria_left_arm_outer",
            rotate: '90deg',
            easing: 'linear',
            duration: 900,
            begin: options.begin
          })
      }, options, this)()
    },
    uncross_arms(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#ria_left_arm",
            rotate: '0deg',
            easing: 'linear',
            duration: 700,
            begin: options.begin
          })
          .add({
            offset: '-=700',
            targets: "#ria_left_arm_outer",
            rotate: '0deg',
            easing: 'linear',
            duration: 900,
            begin: options.begin
          })
      }, options, this)()
    },
    wave(options) {
      return createAnimation((tl, options) => {
        tl
          // full raised arm
          .add({
            targets: "#ria_right_arm",
            rotate: '-25deg',
            easing: 'linear',
            duration: 500,
            begin: options.begin
          })
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-110deg',
            easing: 'linear',
            duration: 500
          })
          // wave
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-120deg',
            easing: 'linear',
            duration: 500,
          })
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-110deg',
            easing: 'linear',
            duration: 500
          })
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-120deg',
            easing: 'linear',
            duration: 500,
          })
          .add({
            targets: "#ria_right_arm_hand",
            rotate: '-110deg',
            easing: 'linear',
            duration: 500,
            complete: () => {
              this.lowerRightArm({
                delay: 500,
                complete: options.complete
              })
            }
          })
      }, options, this)()
    }
  }
}

export { ria_animations }



// WEBPACK FOOTER //
// ./src/components/module_5/js/ria_animations.js